export const title = 'Atlas';
const tabletBreakpointValue = 1024;
export const mobileBreakpointValue = 767;
export const mobileBreakpoint = mobileBreakpointValue + 'px';
export const tabletBreakpoint = tabletBreakpointValue + 'px';
export const contentWidth = '1264px';
export const blockContentWidth = '1816px';
export const IS_CONTENT_CONSUMED_THRESHOLD = 0.3;
export const maxFileSize = 15728640;
